import { render, staticRenderFns } from "./Regions.vue?vue&type=template&id=e793e7ca&scoped=true"
import script from "./Regions.vue?vue&type=script&lang=ts"
export * from "./Regions.vue?vue&type=script&lang=ts"
import style0 from "./Regions.vue?vue&type=style&index=0&id=e793e7ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e793e7ca",
  null
  
)

export default component.exports